'use client'

import useSWR, { type SWRResponse } from 'swr'

import {
  NowControllerV4ApiFactory,
  type NowMerchantV3,
} from '@redteclab/api/clients/composition-service-transactions'

import { useGlooApi } from '../../../api'
import { useGlobalConfigContext } from '../../../global-config'

const getNowApiSwrGetMerchantDetailsKey = ({
  language,
  sellerId,
  tenant,
}: {
  language: string
  sellerId: string
  tenant: string
}): string[] => {
  return ['useNowApiSwrGetMerchantDetails', tenant, language, sellerId]
}

export const useNowApiSwrGetMerchantDetails = ({
  sellerId,
}: {
  sellerId: string
}): SWRResponse<NowMerchantV3, Error> => {
  const client = useGlooApi(NowControllerV4ApiFactory)
  const globalConfig = useGlobalConfigContext()

  const fetcher = async (): Promise<NowMerchantV3> => {
    const response = await client.nowV4TenantLanguageNowMerchantSellerIdGet({
      language: globalConfig.language,
      sellerId,
      tenant: globalConfig.tenantAndEnv,
    })

    return response.data.merchant
  }

  return useSWR(
    sellerId
      ? getNowApiSwrGetMerchantDetailsKey({
          language: globalConfig.language,
          sellerId,
          tenant: globalConfig.tenantAndEnv,
        })
      : null,
    fetcher,
  )
}
